export default "__VITE_ASSET__CsxZY0uH__"